import CustomerCommand from '../../../../services/command/customer/CustomerCommand.services';
import {
    getCustomerApiCountryId,
    getCustomerApiCultureCode,
    buildStoreReceiptFileName,
    downloadPdfFromBlob,
    previewPdfFromBlob,
    resolveStoreReceiptBlob,
    type StoreReceiptDisplayMode,
} from './customerStoreOrders.helpers';
import { mapCustomerOrderSummaryListResponse, mapCustomerStoreOrderDetailResponse } from './customerStoreOrders.mapper';
import type {
    FetchStoreOrderListParams,
    FetchStoreOrderListResult,
    StoreOrderDetailView,
} from './customerStoreOrders.types';
import { STORE_ORDER_LIST_TYPE } from './customerStoreOrders.types';
import Swal from 'sweetalert2';

const PLATFORM_TYPE = 0;

export const fetchStoreOrderSummaryList = async (
    params: FetchStoreOrderListParams
): Promise<FetchStoreOrderListResult> => {
    const res = await CustomerCommand.CustomerOrderSummaryList({
        customerId: params.customerId,
        orderListType: params.orderListType,
        cultureCode: getCustomerApiCultureCode(),
        countryId: getCustomerApiCountryId(),
        timeFilter: params.timeFilter?.trim() ?? '',
        searchFilter: params.searchFilter?.trim() ?? '',
        take: params.take,
        skip: params.skip,
    });
    return mapCustomerOrderSummaryListResponse(res);
};

export const fetchStoreOrderDetail = async (
    customerId: number,
    orderNumber: string,
    orderListType: number = STORE_ORDER_LIST_TYPE
): Promise<StoreOrderDetailView | null> => {
    const res = await CustomerCommand.GetCustomerStoreOrderInformation({
        customerId,
        orderNumber,
        cultureCode: getCustomerApiCultureCode(),
        platformType: PLATFORM_TYPE,
        orderListType,
    });
    const mapped = mapCustomerStoreOrderDetailResponse(res);
    if (!mapped && (res as { message?: string })?.message) {
        throw new Error(String((res as { message?: string }).message));
    }
    return mapped;
};

export const downloadStoreReceipt = async (
    params: {
        orderNumber: string;
        customerId: number;
        orderDate: string;
    },
    displayMode: StoreReceiptDisplayMode = 'download'
): Promise<void> => {
    try {
        const res = await CustomerCommand.GetStoreReceipt({
            orderNumber: params.orderNumber,
            customerId: params.customerId,
            countryId: getCustomerApiCountryId(),
            orderDate: params.orderDate,
        });
        const blob = await resolveStoreReceiptBlob(res);
        if (blob) {
            const fileName = buildStoreReceiptFileName(params.orderNumber);
            if (displayMode === 'preview') {
                previewPdfFromBlob(blob, fileName);
            } else {
                downloadPdfFromBlob(blob, fileName);
            }
            return;
        }
        Swal.fire('', ' ', 'error');
    } catch (error: unknown) {
        const err = error as { data?: { message?: string }; message?: string };
        const message =
            (typeof err?.data === 'object' && err?.data?.message) ||
            (typeof err?.data === 'string' ? err.data : '') ||
            err?.message;
        Swal.fire(message || '', ' ', 'error');
        throw error;
    }
};
